import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyALRTDF7I_yEsR6GmNBJyqD_bAAwdOYzjw",
  authDomain: "latika-dev.firebaseapp.com",
  projectId: "latika-dev",
  storageBucket: "latika-dev.firebasestorage.app",
  messagingSenderId: "90165971711",
  appId: "1:90165971711:web:540302ce6e379280575aca",
  measurementId: "G-441214NTCG"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
